export const CustomTooltipArrow = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute -bottom-[12px] left-[calc(50%+5px)] -translate-x-1/2"
  >
    <path d="M0.5 12V0H12.5L0.5 12Z" fill="#414141" />
  </svg>
);
